@if (item) {

<div class="contentContainer" [ngClass]="{'selected': selected}">
	@if (isModelSize) {
	<div class="content">
		<div class="left">{{item.Hbox}}</div>
		<div class="center" [innerHTML]="replaceHash(item.Code)"></div>		
		<div class="right">{{item.DblWithAdditionalSizeInfo}}</div> 
	</div>
	}

	@if (!isModelSize && !isGemstone) {
	<div class="content">
		<span class="name" [innerHTML]="item[name]"></span>
	</div>
	}

	@if (item && image(item) && !isGemstone) {
	<div class="img">
		<img [src]="image(item)" [alt]="item[name]" />
	</div>
	}

	@if (isGemstone && !isModelSize) {
	<div class="content gemstone">
		<img [src]="image(item)" [alt]="item[name]" />
		<div class="name" [innerHTML]="item[name]"></div>
	</div>
	}

	<availability-text [variantOrModelIsNew]="variantOrModelIsNew" [date]="item.Discontinued" [new]="item.New" [useNewDetails]="false"></availability-text>
</div>

}
@else {

<div class="inner-column">
	@if (noneChoiceImage) {
	<div class="img">
		<img [src]="noneChoiceImage" alt="{{noneChoiceTranslation | translate}}" />
	</div>
	}

	{{noneChoiceTranslation | translate}}
</div>

}

@if (selected && showOverlay) {

<menu-overlay [mainOverlayText]="null" [secondOverlayText]="'CUSTOMIZER.CHANGES.BAGUPDATED' | translate" (overlayClicked)="null">
</menu-overlay>

}